// @ts-strict-ignore
import { UserGuidedTourActionNames, type UserGuidedTourActionType } from './actions';
import { type IUserGuidedToursState } from './interfaces';

const initialState: IUserGuidedToursState = {
  toursVisible: [],
  toursReady: [],
  currentStep: {},
  startStep: {},
};

export const userGuidedToursReducer = (
  state: IUserGuidedToursState = initialState,
  action?: UserGuidedTourActionType,
): IUserGuidedToursState => {
  switch (action.type) {
    case UserGuidedTourActionNames.SHOW_TOUR:
    case UserGuidedTourActionNames.HIDE_TOUR: {
      const { type } = action;
      const { tourId } = action.payload;
      const isVisible = type === UserGuidedTourActionNames.SHOW_TOUR;

      return {
        ...state,
        toursVisible: isVisible ? [...state.toursVisible, tourId] : state.toursVisible.filter((id) => id !== tourId),
      };
    }
    case UserGuidedTourActionNames.TOUR_READY: {
      const { tourId, isReady } = action.payload;

      return {
        ...state,
        toursReady: isReady ? [...state.toursReady, tourId] : state.toursReady.filter((id) => id !== tourId),
      };
    }
    case UserGuidedTourActionNames.SET_TOUR_STEP: {
      const { tourId, step } = action.payload;
      const isFirstStepSet = !(tourId in state.startStep);

      return {
        ...state,
        currentStep: {
          ...state.currentStep,
          [tourId]: step,
        },
        startStep: {
          ...state.startStep,
          ...(isFirstStepSet ? { [tourId]: step } : {}),
        },
      };
    }
    case UserGuidedTourActionNames.RESET_TOUR: {
      const { tourId } = action.payload;
      const { [tourId]: currentStepValue, ...restCurrentStep } = state.currentStep;
      const { [tourId]: startStepValue, ...restStartStep } = state.startStep;

      return {
        ...state,
        currentStep: restCurrentStep,
        startStep: restStartStep,
      };
    }
    default:
      return state;
  }
};
